// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4e5bc65f","732":"6e47bbed","977":"a482d267"}[chunkId] + ".chunk.js";
};